// How the transcript writes a count, a length of time and why a turn
// stopped. Moved from today's Code tab (code/format.ts there).

const one = (value: number) => String(Math.round(value * 10) / 10)

/** How long a turn took: `0.4 s`, `41 s`, `3 min 4 s`, `1 h 12 min`. */
export function durationText(ms: number): string {
  const span = Math.max(0, ms)
  if (span < 10_000) return `${one(span / 1_000)} s`
  const seconds = Math.round(span / 1_000)
  if (seconds < 60) return `${seconds} s`
  const minutes = Math.floor(seconds / 60)
  if (minutes < 60) return seconds % 60 ? `${minutes} min ${seconds % 60} s` : `${minutes} min`
  const hours = Math.floor(minutes / 60)
  return minutes % 60 ? `${hours} h ${minutes % 60} min` : `${hours} h`
}

/** `1 call`, `12 calls`. */
export function countText(count: number, singular: string, plural = `${singular}s`): string {
  return `${count} ${count === 1 ? singular : plural}`
}

/**
 * How a turn's stop reason reads; '' for a turn that simply ended. ACP's
 * `cancelled` is a turn someone interrupted, as today's words have it.
 */
export function stopText(reason: string | null | undefined): string {
  if (!reason || reason === 'end_turn') return ''
  if (reason === 'cancelled') return 'interrupted'
  return reason.replace(/_/g, ' ')
}
